Hop.defineModule('signup-open-modal', (domRoot) => {
    const modale = document.querySelector('.js-signup-modale');
    const closeModaleButton = document.querySelector('.js-signup-close-modale');

    function closeModale() {
        modale.classList.remove('open');
    }

    function openModale() {
        modale.classList.add('open');
    }

    function listenToUserAction() {
        if (modale && closeModaleButton) {
            domRoot.addEventListener('click', openModale);
            closeModaleButton.addEventListener('click', closeModale);
        }
    }

    listenToUserAction();
});
